import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  Input,
  signal,
  ViewChild
} from '@angular/core';
import { faMapMarkerAlt, faChevronUp } from '@fortawesome/free-solid-svg-icons';

import { getMovieGenres, getMovieTags, PerformanceGroup } from '@usheru-hff/shared/domain';
import { TRACKING_SERVICE, TrackingService } from '@usheru-hff/sdk/tracking';

import { ShowtimesStoreService } from '../../shared/showtimes.service';

@Component({
  selector: 'showtime-streaming-map',
  templateUrl: './showtime-streaming-map.component.html',
  styleUrls: ['./showtime-streaming-map.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ShowtimeStreamingMapComponent {
  @ViewChild('closeInlineRef') closeInlineRef: ElementRef<HTMLElement>;

  @Input()
  perfGroup: PerformanceGroup;

  @Input()
  focusElementOnClose: ElementRef<HTMLElement>;

  movie = this.showtimesStore.movie;
  inlineMap = this.showtimesStore.inlineMap;

  isOpen = signal<boolean>(false);
  markerIcon = faMapMarkerAlt;
  closeIncon = faChevronUp;

  constructor(
    @Inject(TRACKING_SERVICE) private trackingService: TrackingService,
    private showtimesStore: ShowtimesStoreService,
    private changeDetector: ChangeDetectorRef
  ) {}

  /**
   * @docsNotRequired
   */
  openMap() {
    this.isOpen.set(true);
    this.changeDetector.detectChanges();
    this.trackingService.trackEvent({
      action: 'OpenMap',
      properties: {
        category: 'MovieShowtimes',
        label: `${this.movie().title} @ ${this.perfGroup.cinema.name}`,
        movie: this.movie().title,
        idMovie: this.movie().id,
        imdb: this.movie().imdb,
        cinema: this.perfGroup.cinema.name,
        idCinema: this.perfGroup.cinema.id,
        tagsMovie: getMovieTags(this.movie()),
        genresMovie: getMovieGenres(this.movie())
      }
    });
  }

  closeInlineMap() {
    this.isOpen.set(false);
    this.changeDetector.detectChanges();

    this.focusElementOnClose?.nativeElement.focus();
  }

  keyupCloseInlineMap(event: KeyboardEvent) {
    if (event.key === 'Enter' || event.key === ' ') {
      this.closeInlineMap();
    }
  }

  /**
   * @docsNotRequired
   * //TODO barbeitoalex propostal - remane to "hideMap"?Pho
   */
  onHideMap() {
    this.isOpen.set(false);

    this.changeDetector.detectChanges();
  }

  /**
   * Checks if the {@link perfGroup} has a valid address.
   * @returns
   */
  addressExists(performance: PerformanceGroup): string {
    return performance?.cinema?.place?.address?.includes('null null') ? '' : performance?.cinema?.place?.address;
  }

  closeMapKeydown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.closeInlineMap();
    }
  }
}
